// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.v-select.fit[data-v-9fe5b3ee] {\n  width: -webkit-min-content;\n  width: -moz-min-content;\n  width: min-content;\n}\n.v-select.fit  .v-select__selection--comma[data-v-9fe5b3ee] {\n    text-overflow: unset;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
